import React from 'react';
import ReactDOM from 'react-dom';
import { Form, Progress } from 'antd';
const FormItem = Form.Item;
// import { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute } from './sgiFormCtlComm';
import moment from 'moment';
// import { sgiFormCtlBaseFun } from "./sgiFormCtlBaseFun";

class SgiProgress extends React.Component {

    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号

    constructor(props) {
        super(props);

        //初始化state属性
        // this.initState();
        this.state = {
            inputprops: {
                style: { width: "100%" },
            },//存放input属性
        };
        var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
        //组装属性 初始化属性到this.state
        this.progress_mk(parentModule, moduleDesc, bdInst, objFct, type);
    }

    /**
     * 根据描述创建文本框
     * @param {父组件} parentModule
     * @param {组件描述} moduleDesc
     * @param {绑定实例ID} bdInst
     * @param {当前工作区} ws
     * @param {make类型} type
     */
    progress_mk(parentModule, moduleDesc, bdInst, workspace, type) {

        //获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }

        //转换基础属性
        this.AddInputAttribute(moduleDesc, this.state.inputprops);
        //转换form公共属性
        // AddFormCtlCommonAttribute(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
        //设置布局
        // setFormCtlLayout(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //绑定事件
        // bindEvent(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
        //绑定值
        // bindValue(this, moduleDesc, bdInst, this.state.formItemProps, this.state.inputprops);
    }


    /**
     * 属性转换
     * @param {描述信息} moduleDesc
     * @param {属性} formItem
     * @param {属性} inputprops
     */
    AddInputAttribute(moduleDesc, inputprops) {
        var percent = moduleDesc.percent; //百分比
        if (percent) inputprops.percent = percent;

        var status = moduleDesc.status; //status 状态，可选：success exception active
        if (status) inputprops.status = status;

        var showInfo = moduleDesc.showInfo; // 是否显示进度数值或状态图标
        if (showInfo) inputprops.showInfo = showInfo;

        var type = moduleDesc.type; // 类型，可选 line circle dashboard
        if (type) inputprops.type = type;

        // var size = moduleDesc.size; //线型大小，不好用
        // if (size) inputprops.size = size;

        //进度条线的宽度，单位 px,10; 圆形进度条线的宽度，单位是进度条画布宽度的百分比,6
        var strokeWidth = moduleDesc.strokeWidth;
        if (strokeWidth) inputprops.strokeWidth = strokeWidth;

        var width = moduleDesc.width;// 圆形进度条画布宽度，单位 px,132
        if (type == 'circle' && width) inputprops.width = width;

        var format = moduleDesc.format;// 自定义文字格式
        if(format){
          inputprops.format = (percent) => {
            return `${percent}` + format;
          }
        }

        // var successPercent = moduleDesc.successPercent;// 已完成的分段百分比，type="line" 时有效,0
        // if (successPercent) inputprops.successPercent = successPercent;
    }

    //渲染并返回一个虚拟DOM
    render = function () {
        return (
            <Progress {...this.state.inputprops} />
        );
    }
}

//给类添加公共方法
// Object.assign(SgiProgress.prototype, sgiFormCtlBaseFun);

export { SgiProgress };
export default SgiProgress;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiProgress.js